import {
  PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useLocation } from 'react-router-dom';

import { fetchNotifications } from 'modules/main/store/ducks/userNotifications.actions';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';

export const LayoutContext = createContext({});

export const useLayoutContext = () => useContext(LayoutContext);

export function LayoutProvider({ children }: PropsWithChildren) {
  const dispatch = useMainDispatch();

  const location = useLocation();

  const { user, isEnvironmentLoaded, isUserLoaded } = useUserEnvironment();

  const [isLoaded, setIsLoaded] = useState(false);

  // Fetch notifications on each location change
  useEffect(() => {
    if (!isEnvironmentLoaded) return;
    if (!isUserLoaded) return;

    if (user?.hasNotifications) {
      dispatch(fetchNotifications()).then(() => setIsLoaded(true));
    } else {
      setIsLoaded(true);
    }
  }, [
    location.pathname,
    user?.hasNotifications,
    isEnvironmentLoaded,
    isUserLoaded,
    dispatch,
  ]);

  return (
    <LayoutContext.Provider value={isLoaded}>{children}</LayoutContext.Provider>
  );
}
